module.exports = __webpack_public_path__ + "static/media/ogimpact-dashboard.0d4b9ab3.jpg";